import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import BlogHeader from './components/BlogHeader';
import AllBlogPosts from './components/AllBlogPosts';
import PartnersSection from '../Home/components/PartnersSection';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const BlogPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav />
      <PageHeaders
        title="Finance 101: Retirement, 401k & Investing Basics | Plootus"
        description="Learn retirement and personal finance fundamentals with Plootus Finance 101 — clear, unbiased guides covering 401k basics, fund selection, contribution limits, budgeting, and long-term investing. Free for everyone."
        keywords="Plootus blogs, financial blogs, retirement planning, investment tips, personal finance, wealth management, 401k advice, financial planning"
        ogTitle="Finance 101 by Plootus — Free Retirement & Investing Guides"
        ogDescription="Plain-English guides to 401k plans, investment funds, retirement calculators, and personal finance basics. No jargon, no fees."
        ogImage='Educational hub branded image — topic category grid or "Finance 101" hero visual, optimized for sharing on social and LinkedIn'
        canonicalUrl="https://www.plootus.com/finance-101"
      />
      <BlogHeader />
      <PartnersSection titleDisabled={true} rootPadding="0"/>
      <AllBlogPosts />
    </div>
  );
};

export default BlogPage;
